// extracted by mini-css-extract-plugin
export default {"mCard":"Ft-z","image":"Gt-z","imageNoBackground":"Ht-z","imageHasCategory":"It-z","fullWidth":"Jt-z"};